// Where section settings open: a floating popover next to the section (default)
// or a docked sidebar on the right side of the editor. Remembered per viewer.
export const SectionSettingsModeEnum = Object.freeze({
    FLOATING: 'floating',
    DOCKED: 'docked',
});

const STORAGE_KEY = 'uxfolio.sectionSettingsMode';

export function readSectionSettingsMode() {
    try {
        const stored = window.localStorage.getItem(STORAGE_KEY);
        return stored === SectionSettingsModeEnum.DOCKED ? SectionSettingsModeEnum.DOCKED : SectionSettingsModeEnum.FLOATING;
    } catch (e) {
        return SectionSettingsModeEnum.FLOATING;
    }
}

export function writeSectionSettingsMode(mode) {
    try {
        window.localStorage.setItem(STORAGE_KEY, mode);
    } catch (e) {
        // Storage can be unavailable (private mode, blocked site data); the choice then lasts for this page load only.
    }
}

// Identifies one SectionEditButtons instance: a navigation section has a separate logo toolbar.
export function sectionSettingsOwnerKey(sectionId, isLogoEdit = false) {
    return `${sectionId}:${isLogoEdit ? 'logo' : 'section'}`;
}
